import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm, UseFormRegister } from 'react-hook-form';

import BasicModal from 'components/Common/BasicModal';
import FormTextarea from 'components/Common/FormTextarea';

import { sanitizeAndDeleteHtml } from 'helpers/htmlParser';
import { Inputs, Props } from './types';

import { Box } from '@mui/material';

export const RewriteModal: FC<Props> = ({ open, onClose, markedHtml, onRewrite }) => {
    const { t } = useTranslation();
    const { handleSubmit, control, register, reset } = useForm<Inputs>({
        mode: 'onBlur',
        defaultValues: {
            prompt: '',
        },
    });

    const registerWithValidation: UseFormRegister<Inputs> = ((name) =>
        register(name, {
            required: t('web_app.rewrite_modal.prompt_required'),
            validate: (value: string) =>
                value.trim() !== '' || t('web_app.rewrite_modal.prompt_required'),
        })) as UseFormRegister<Inputs>;

    const onSubmit = (values: Inputs) => {
        const sanitizedPrompt = sanitizeAndDeleteHtml(values.prompt);

        onRewrite({
            markedHtml,
            prompt: sanitizedPrompt,
        });

        reset({ prompt: '' });
    };

    const handleClose = () => {
        reset({ prompt: '' });
        onClose();
    };

    return (
        <BasicModal open={open} onClose={handleClose}>
            <Box className="rewrite-modal">
                <Box className="rewrite-modal-title">
                    {t('web_app.rewrite_modal.rewrite_selected_text')}
                </Box>
                <Box className="rewrite-modal-content">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <FormTextarea
                            name="prompt"
                            title={t('web_app.rewrite_modal.rewrite_prompt')}
                            register={registerWithValidation}
                            control={control}
                        />
                        <Box className="rewrite-modal-content-btns">
                            <button type="button" onClick={handleClose}>
                                {t('web_app.rewrite_modal.cancel')}
                            </button>
                            <button type="submit">{t('web_app.rewrite_modal.rewrite')}</button>
                        </Box>
                    </form>
                </Box>
            </Box>
        </BasicModal>
    );
};
